import comp from "./EditOrCreateEvent";
export default comp;
